import { useState, useEffect } from 'react'
import { TableContainer, Paper, Collapse } from '@mui/material'
import { groupBy } from 'lodash'

import searchInExpenseAndEcritures from '../../utils/searchLogic'
import {
  calculateExpensesSums,
  calculateTypeSums,
} from '../../utils/expensesSumsLogic'

import ExpensesTableBody from './ExpensesTableBody'
import ExpensesTableSection from './ExpensesTableSection'

const ExpensesTable = ({ expenses, search, sortEcritures }) => {
  const [open, setOpen] = useState({})

  const [groupedByTypeAndAccount, setGroupedByTypeAndAccount] = useState({})
  const [
    groupedByTypeAndAccountAndRubrique,
    setGroupedByTypeAndAccountAndRubrique,
  ] = useState({})

  if (!expenses || !Array.isArray(expenses)) {
    return (
      <div
        style={{
          minHeight: '200px',
          background: 'white',
          fontSize: '24px',
          justifyContent: 'center',
          verticalAlign: 'middle',
          display: 'flex',
          alignItems: 'center',
        }}
      >
        Probléme lors du chargements des données de RGDD...
      </div>
    )
  }

  useEffect(() => {
    const groupedByType = groupBy(expenses, 'type')
    const groupedByTypeAndAccountTemp = {}
    const groupedByTypeAndAccountAndRubriqueTemp = {}

    // Create groupe by type and account/rubrique
    for (const type in groupedByType) {
      groupedByTypeAndAccountTemp[type] = groupBy(groupedByType[type], 'compte')
      groupedByTypeAndAccountAndRubriqueTemp[type] = groupBy(
        groupedByType[type],
        (expense) => `${expense.compte}-${expense.rubrique}`
      )
    }

    // Search in expenses
    if (search.length >= 3) {
      for (const type in groupedByTypeAndAccountAndRubriqueTemp) {
        for (const key in groupedByTypeAndAccountAndRubriqueTemp[type]) {
          if (
            Object.prototype.hasOwnProperty.call(
              groupedByTypeAndAccountAndRubriqueTemp[type],
              key
            ) &&
            Array.isArray(groupedByTypeAndAccountAndRubriqueTemp[type][key])
          ) {
            groupedByTypeAndAccountAndRubriqueTemp[type][key] =
              searchInExpenseAndEcritures(
                groupedByTypeAndAccountAndRubriqueTemp[type][key],
                search
              )
          }
        }
      }
    }

    setGroupedByTypeAndAccount({ ...groupedByTypeAndAccountTemp })
    setGroupedByTypeAndAccountAndRubrique({
      ...groupedByTypeAndAccountAndRubriqueTemp,
    })

    // Open first type (charge) at loading new expenses
    if (expenses && expenses.length > 0) {
      const firstTypeKey = Object.keys(groupedByTypeAndAccountTemp)[0]
      setOpen({ [firstTypeKey]: true })
    }
  }, [expenses, search])

  const handleOpen = (key) => {
    setOpen((prevOpen) => ({ ...prevOpen, [key]: !prevOpen[key] }))
  }

  return (
    <TableContainer
      component={Paper}
      style={{ padding: '15px', paddingLeft: '25px', minHeight: '200px' }}
    >
      {Object.entries(groupedByTypeAndAccount).map(([type, accounts]) => {
        const typeSums = calculateTypeSums(accounts, type)
        return (
          <div key={type}>
            {/* Expanding Button for type charge/produit */}
            <ExpensesTableSection
              label={`${type}s`}
              open={open[type]}
              handleOpen={() => handleOpen(type)}
              sums={typeSums}
              fontSizeCell={'20px'}
              paddingLeft={'0px'}
              type={type}
            />

            <Collapse in={open[type]} timeout="auto" unmountOnExit>
              {Object.entries(groupedByTypeAndAccountAndRubrique[type])
                .sort((a, b) => {
                  const compteA = a[1][0] ? a[1][0].compte : ''
                  const compteB = b[1][0] ? b[1][0].compte : ''
                  return compteA.localeCompare(compteB)
                })
                .map(([key, expensesByRubrique]) => {
                  if (expensesByRubrique.length > 0) {
                    const sums = calculateExpensesSums(expensesByRubrique, type)
                    return (
                      <div key={key}>
                        {/* Expanding Button for compte/rubrique */}
                        <ExpensesTableSection
                          label={`${
                            expensesByRubrique[0].compte
                          } - ${expensesByRubrique[0].rubrique
                            .toString()
                            .padStart(4, '0')} - ${
                            expensesByRubrique[0].libelle
                          }`}
                          open={open[key]}
                          handleOpen={() => handleOpen(key)}
                          sums={sums}
                          fontSizeCell={'17px'}
                          paddingLeft={'15px'}
                        />

                        {/* Table with the Expenses Data */}
                        <ExpensesTableBody
                          open={open[key]}
                          expensesByRubrique={expensesByRubrique}
                          sortEcritures={sortEcritures}
                          type={type}
                        />
                      </div>
                    )
                  }
                })}
            </Collapse>
          </div>
        )
      })}
    </TableContainer>
  )
}

export default ExpensesTable
